import { consumeRoutePrefetch, startRoutePrefetch } from '@/lib/api/routePrefetch'
import { fetchProfileBootstrap } from './api'
import type { PlayerBootstrapResponse } from './types'

/**
 * Route-entry prefetch for the profile bootstrap (perf — /profile speedup).
 * Mirrors features/clubs/prefetch so the router's entry wrapper and
 * usePlayerView agree on the key. The bootstrap is the /profile critical read;
 * starting it during the route transition runs it in parallel with the lazy
 * page chunk instead of after mount.
 *
 * Keyed by playerId + orgId + recentLimit so a consumer only takes a request
 * shaped exactly like the one it would have fired itself. The /profile entry
 * prefetches with no orgId (the page's own load uses none) and recentLimit=5.
 */
function bootstrapKey(playerId: string, orgId: string, recentLimit: number | undefined): string {
  return `players:bootstrap:${playerId}:${orgId}:${recentLimit ?? ''}`
}

export function prefetchProfileBootstrap(playerId: string, recentLimit?: number): void {
  const id = String(playerId || '').trim()
  if (!id) return
  startRoutePrefetch(bootstrapKey(id, '', recentLimit), () =>
    fetchProfileBootstrap(id, undefined, recentLimit),
  )
}

export function consumeProfileBootstrapPrefetch(
  playerId: string,
  orgId: string,
  recentLimit?: number,
): Promise<PlayerBootstrapResponse> | null {
  const id = String(playerId || '').trim()
  if (!id) return null
  return consumeRoutePrefetch<PlayerBootstrapResponse>(bootstrapKey(id, orgId, recentLimit))
}
